/* ============================================================
   CURRENTLY — gallery mega menu (desktop dropdown redesign)
   Restyles the desktop header dropdowns (.header__dropdown) as
   full-width gallery index panels: numbered rows, hairline rules,
   small-caps overline, featured campaign image.
   Reads the menu's own links — stays in sync automatically.
   Desktop only; mobile drawer untouched. Reversible: remove the
   two lines from theme.liquid and delete these assets.
   ============================================================ */
(function () {
  'use strict';

  /* Featured panel per menu. Swap any value — images hotlink from your own CDN. */
  var FEATURED = {
    'MEN': {
      img: 'https://cdn.shopify.com/s/files/1/0718/5583/3377/files/BC5B9F54-0497-4398-A522-DDB24A7FCE71.jpg?v=1786892117',
      title: 'The Long Run',
      sub: 'Iceland — FW26',
      href: '/pages/iceland'
    },
    'WOMEN': {
      img: 'https://cdn.shopify.com/s/files/1/0718/5583/3377/files/Slide_37.jpg?v=1789480526',
      title: 'Track Season',
      sub: 'Iceland — FW26',
      href: '/pages/iceland'
    }
  };

  function cleanText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function featureAside(f) {
    var aside = document.createElement('aside');
    aside.className = 'cr-mega-feature';
    var a = document.createElement('a');
    a.className = 'cr-mega-ph';
    a.href = f.href || '#';
    var img = document.createElement('img');
    img.src = f.img;
    img.alt = f.title || '';
    img.loading = 'lazy';
    var cap = document.createElement('div');
    cap.className = 'cr-mega-cap';
    var t = document.createElement('div');
    t.className = 't';
    t.textContent = f.title || '';
    var s = document.createElement('div');
    s.className = 's';
    s.textContent = f.sub || '';
    cap.appendChild(t);
    cap.appendChild(s);
    a.appendChild(img);
    a.appendChild(cap);
    aside.appendChild(a);
    var note = document.createElement('div');
    note.className = 'cr-mega-note';
    var n1 = document.createElement('span');
    n1.textContent = 'Featured';
    var n2 = document.createElement('a');
    n2.href = f.href || '#';
    n2.setAttribute('style', 'color:inherit;text-decoration:none;');
    n2.textContent = 'View lookbook \u2192';
    note.appendChild(n1);
    note.appendChild(n2);
    aside.appendChild(note);
    return aside;
  }

  function buildPanel(item) {
    var dropdown = item.querySelector(':scope > .header__dropdown');
    if (!dropdown || dropdown.dataset.crMega) return;

    var topLink = item.querySelector(':scope > a.navlink--toplevel');
    var label = topLink ? cleanText(topLink.querySelector('.navtext') || topLink) : '';
    var topHref = topLink ? topLink.getAttribute('href') : '#';
    if (!label) return;

    var inner = dropdown.querySelector('.header__dropdown__inner');
    if (!inner) return;

    dropdown.dataset.crMega = '1';
    dropdown.classList.add('cr-mega');

    /* overline: LABEL — INDEX  .........  View all → */
    var over = document.createElement('div');
    over.className = 'cr-mega-overline';
    var os = document.createElement('span');
    os.textContent = label + ' \u2014 Index';
    var oa = document.createElement('a');
    oa.href = topHref;
    oa.textContent = 'View all \u2192';
    over.appendChild(os);
    over.appendChild(oa);

    if (!item.classList.contains('grandparent')) {
      /* two-level menu (MEN, WOMEN): numbered index + featured image */
      var links = Array.prototype.slice.call(
        inner.querySelectorAll(':scope > a.navlink--child')
      );

      var main = document.createElement('div');
      main.className = 'cr-mega-main';
      main.appendChild(over);

      var rows = document.createElement('nav');
      rows.className = 'cr-mega-rows';
      var n = 0;
      links.forEach(function (a) {
        var txt = cleanText(a.querySelector('.navtext') || a);
        if (!txt) return;
        n += 1;
        a.classList.add('cr-mega-row');
        a.textContent = '';
        var num = document.createElement('span');
        num.className = 'cr-mega-num';
        num.textContent = String(n).padStart(2, '0');
        var lab = document.createElement('span');
        lab.className = 'cr-mega-label';
        lab.textContent = txt;
        var arr = document.createElement('span');
        arr.className = 'cr-mega-arrow';
        arr.textContent = '\u2192';
        a.appendChild(num);
        a.appendChild(lab);
        a.appendChild(arr);
        if (/^shop all$/i.test(txt)) a.classList.add('cr-shopall');
        rows.appendChild(a);
      });
      main.appendChild(rows);

      inner.textContent = '';
      inner.appendChild(main);

      var f = FEATURED[label.toUpperCase()];
      if (f) inner.appendChild(featureAside(f));
    } else {
      /* three-level menu (STORIES): family columns, gallery-styled */
      inner.classList.add('cr-mega-families');
      inner.insertBefore(over, inner.firstChild);
      inner.querySelectorAll('.dropdown__family').forEach(function (fam) {
        var head = fam.querySelector(':scope > a.navlink--child');
        if (head) head.classList.add('cr-fam-head');
        fam.querySelectorAll(':scope > a.navlink--grandchild').forEach(function (g) {
          g.classList.add('cr-fam-link');
        });
      });
    }
  }

  function run() {
    document
      .querySelectorAll('.header__desktop .menu__item.parent, .header__desktop .menu__item.grandparent')
      .forEach(buildPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
